<script setup lang="ts">
import { routeNames } from '@/router/routeNames'
</script>

<template>
  <RouterLink :to="{ name: routeNames.Dashboard }">
    <img
      src="../../../assets/logo-transparent-2.png"
      alt="Logo"
      class="h-8 w-auto"
    />
  </RouterLink>
</template>
